<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Department" subTitle="Forms" />

    <CreateDepartment />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateDepartment from "@/components/Pages/Master/Department/CreateDepartment.vue";

export default defineComponent({
  name: "CreateDepartmentPage",
  components: {
    PageTitle,
    CreateDepartment,
  },
});
</script>
